/* eslint-disable max-len */
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { Panel } from 'primereact/panel';
import { NotificationContext } from '../../../components/GrowlNotifications';
import { clearCredentialsSession, persistCredentialsSession } from '../../../services/auth/auth-storage';
import runAcessTokenChecker from '../../../services/auth/auth-scheduler';
import { clearLoggedAccount } from '../../../reducers/account';
import {
  buildAcceptEssentialAccountInvitationFormInitialValues,
  buildAcceptEssentialAccountInvitationFormValidationSchema,
  extractInput,
} from '../helpers/account-invitation-helper';
import EssentialAccountInvitationForm from './EssentialAccountInvitationForm';
import { growlActionSuccess, growlErrors } from '../../../utils/NotificationUtil';
import { useMutation } from '@apollo/react-hooks';
import { ACCEPT_ESSENTIAL_ACCOUNT_INVITATION } from '../services/account-invitation.service';

const EssentialAccountInvitation = ({ invitation, countries, locales, timeZones, taxIds, token, userExists }) => {
  const growl = useContext(NotificationContext);
  const history = useHistory();

  const [acceptEssentialAccountInvitationMutation] = useMutation(ACCEPT_ESSENTIAL_ACCOUNT_INVITATION);

  const initialValues = buildAcceptEssentialAccountInvitationFormInitialValues(invitation.fullName, invitation.email);
  const validationSchema = buildAcceptEssentialAccountInvitationFormValidationSchema();

  const handleSubmit = async (values) => {
    const input = extractInput(values, userExists, token);

    try {
      const result = await acceptEssentialAccountInvitationMutation({
        variables: {
          input,
        },
      });

      const { data } = result;
      const { acceptEssentialAccountInvitation } = data;
      const { userId, createdAccountId, tokens } = acceptEssentialAccountInvitation;

      growlActionSuccess(growl);

      if (!userExists) {
        history.push(`/register-confirmation?userId=${userId}`);
      } else {
        clearLoggedAccount();
        clearCredentialsSession();

        const { token: authenticationToken, refreshToken } = tokens;

        persistCredentialsSession(authenticationToken, refreshToken);
        runAcessTokenChecker();

        history.push(`/accounts/${createdAccountId}`);
      }
    } catch (err) {
      growlErrors(growl);
    }
  };

  return (
    <div className="p-grid p-justify-center">
      <div className="p-sm-12 p-md-10 p-lg-8">
        <Panel>
          <div className="p-grid">
            <div className="p-sm-12">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  handleSubmit(values);
                }}
              >
                <EssentialAccountInvitationForm
                  invitation={invitation}
                  countries={countries}
                  locales={locales}
                  timeZones={timeZones}
                  taxIds={taxIds}
                  token={token}
                  userExists={userExists}
                />
              </Formik>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  );
};

export default EssentialAccountInvitation;
